import { useState, useRef, useEffect} from 'react'
import { useGlobalContext } from '../context'

export const Question = (props) => {
    const questions = props.questions;
    const [index, setIndex] = useState(0);
    const [score, setScore] = useState(0);
    const nextBtn = useRef('');
    const progressBar = useRef(null);

    const { timer } = useGlobalContext();

    const { difficulty, category, answer, choices} = questions[index];
    var { question } = questions[index];
    let answers = [...choices];
    answers.push(answer);

    if (question.includes('&quot;'))
        question = question.replaceAll('&quot;', '"')
    if (question.includes('&#039;'))
        question=question.replaceAll('&#039;',"'")
    if (question.includes('&ldquo;'))
        question = question.replaceAll('&ldquo;', '"')
    if (question.includes('&rdquo;'))
        question = question.replaceAll('&rdquo;', '"')
    if (question.includes('&rsquo;s'))
        question = question.replaceAll('&rsquo;', "'")
    if (question.includes('&hellip;'))
        question = question.replaceAll('&hellip;', '...')
    if (question.includes('&eacute;'))
        question = question.replaceAll('&eacute;', 'é')
    if (question.includes('&amp;'))
        question=question.replaceAll('&amp;','&')
    
    answers.forEach((ans, index)=> {
        if (ans.includes('&quot;'))
            ans = ans.replaceAll('&quot;', '"')
        if (ans.includes('&quot;'))
            ans = ans.replaceAll('&quot;', '"')
        if (ans.includes('&#039;'))
            ans = ans.replaceAll('&#039;', "'")
        if (ans.includes('&ldquo;'))
            ans = ans.replaceAll('&ldquo;', '"')
        if (ans.includes('&rdquo;'))    
            ans = ans.replaceAll('&rdquo;', '"')
        if (ans.includes('&rsquo;s'))
            ans = ans.replaceAll('&rsquo;', "'")
        if (ans.includes('&hellip;'))
            ans = ans.replaceAll('&hellip;', '...')
        if (ans.includes('&eacute;'))
            ans = ans.replaceAll('&eacute;', 'é')
        if (ans.includes('&amp;'))
            ans = ans.replaceAll('&amp;', '&')
        
        answers[index] = ans;
    });

    console.log(answer)
    const shuffle = (array)=> {
        var currentIndex = array.length, temporaryValue, randomIndex;
      
        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
      
          // Pick a remaining element...
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;
      
          // And swap it with the current element.
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }
      
        return array;
      }
      
    const nextQuestion = () => {
        let checkBoxes = (document.querySelectorAll('.custom-control-input'));
        checkBoxes.forEach(checkBox => {
            if (checkBox.checked && checkBox.value === answer) {
                setScore(prevScore => prevScore + 1)
                console.log(score)
            }
        });

        if (progressBar.current)
            progressBar.current.style.width = '100%';
        
        setIndex((index) => {
            let newIndex = index + 1;
            if (newIndex === questions.length - 1)
                nextBtn.current.textContent = 'Finish';
            if (newIndex === questions.length) {
                window.location.assign(`/score/${score}`);
            }
            return newIndex;
        });
       
    };

   
    
    const checkboxHandler = (e) => {
        let checkBoxes = (document.querySelectorAll('.form-check-input'));
        checkBoxes.forEach(checkBox => {
            if (checkBox !== e.target)
                checkBox.checked = false;
            })
    }

    const choiceHandler = (e) => {
        e.target.previousElementSibling.checked = true;
        let checkBoxes = (document.querySelectorAll('.custom-control-input'));
        checkBoxes.forEach(checkBox => {
            if (checkBox !== e.target.previousElementSibling)
                checkBox.checked = false;
            })
    }

   
    
    useEffect(() => {
        if (timer) {
            const interval = setInterval(() => {
              let oldProgress = parseInt(progressBar.current.style.width.replace("%", ''));
                progressBar.current.style.width = `${oldProgress - 1}%`
                console.log(progressBar.current.style.width)
                if (progressBar.current.style.width === '0%') {
                    nextQuestion();
                }
                    
            }, 100);
            return () => clearInterval(interval);
        }
    }, []);
    
    return (
        
        <article className='ml-5 margin-adjust'>
            <div>{timer ? (<div className="progress">
                <div ref={progressBar} className="progress-bar progress-bar-info progress-bar-striped active" style={{ width: '100%'}}></div>
                            </div>) :
                            (<p></p>)}</div>
            <div className='d-flex'>
                <span className="badge-1">Category:{category}</span>
                <span className="badge-2">Difficulty:{difficulty}</span>
            </div>
            <div className='question'>
                <h3 className='mt-3 question-font'>{question}</h3>
                <div>
                    {   
                        shuffle(answers).map(choice => {
                            return (
                                <div key={choice} className="custom-control form-control-md pt-2 custom-checkbox">
                                    <input onClick={checkboxHandler} className="custom-control-input" type="checkbox" value={choice}/>
                                    <label onClick={choiceHandler} className="custom-control-label choice w-100">{choice}</label>     
                                </div>
                            )
                        })
                    } 
                </div>
            </div>      
            <div className='d-flex justify-content-between footer'>
                <div className='button-container pt-2'>
                    <button ref={nextBtn} className='btn next' onClick={nextQuestion}>next</button>
                </div>
                <div className='pt-4 '>
                    <p className='ml-auto pr-4 '>{`${index + 1}/${questions.length}`}</p>
                </div>
            </div>
        </article>
      );
}

export default Question;